import React from 'react';
import { FormattedDate } from 'react-intl';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { validateTimePeriod, isNumber } from '~APP_UTIL/formValidations';
import { TranslatedCopy } from '../intl/TranslatedCopy';

import { H3 } from '../components/';
import Select from '../components/formInputs/Select';
import Calendar from '../components/formInputs/selectComponents/Calendar';
import { todaysDate } from '../util/dateWithoutTimezone';
import { hourOptions, minuteOptions, timePeriodOptions } from './selectOptions';

export const NotificationInputGroup = ({
  from,
  name,
  setDate,
  dateObject,
  fromDateString,
  isStart,
  change,
  notificationLoaded
}) => {
  const { date, hour, minute, timePeriod } = dateObject;
  const toFrom = from ? 'from' : 'to';
  const dateValue = new Date(date);
  const oneYearFromNow = new Date(new Date(dateValue.toString()).setFullYear(dateValue.getFullYear() + 1));
  const fromDate = fromDateString ? new Date(fromDateString) : todaysDate();
  const hourName = `${name}_hour`;
  const minuteName = `${name}_minute`;
  const timePeriodName = `${name}_timePeriod`;
  if (hourOptions && minute && timePeriod && !notificationLoaded) {
    change(hourName, hour.toString());
    change(minuteName, minute);
    const timePeriodInput = { value: timePeriod, label: timePeriod };
    change(timePeriodName, timePeriodInput);
  }

  return (
    <div className='input_group'>
      <H3>
        <TranslatedCopy id={`calendar.label.${toFrom}`} />
      </H3>
      <Calendar
        startDate={fromDate}
        endDate={oneYearFromNow}
        onChange={value => setDate({ name, value })}
        value={dateValue.toUTCString()}
        buttonLabel={<FormattedDate value={dateValue} year='2-digit' month='numeric' day='numeric' timeZone='utc' />}
        isStart={isStart}
      />
      <div className='notifications__select'>
        <Field
          name={hourName}
          component={Select}
          options={hourOptions}
          clearable={false}
          forceDropdown
          validate={[isNumber]}
          normalize={option => option.value}
        />
      </div>
      <p className='delimiter'>:</p>
      <div className='notifications__select'>
        <Field
          name={minuteName}
          component={Select}
          options={minuteOptions}
          clearable={false}
          forceDropdown
          validate={[isNumber]}
          normalize={option => option.value}
        />
      </div>
      <div className='notifications__select time_period ml4-sm'>
        <Field
          name={timePeriodName}
          component={Select}
          options={timePeriodOptions}
          clearable={false}
          validate={[validateTimePeriod]}
        />
      </div>
    </div>
  );
};

NotificationInputGroup.defaultProps = {
  from: false,
  fromDateString: '',
  isStart: false
};

NotificationInputGroup.propTypes = {
  from: PropTypes.bool,
  name: PropTypes.string.isRequired,
  setDate: PropTypes.func.isRequired,
  dateObject: PropTypes.object.isRequired,
  fromDateString: PropTypes.string,
  isStart: PropTypes.bool,
  change: PropTypes.func.isRequired,
  notificationLoaded: PropTypes.bool.isRequired
};

export default NotificationInputGroup;
